import axios from '@/utils/request'
var Qs = require('qs')

export default {
	// 2021-08-09
	costProfitReport(params) {
		return axios.get('/back-order/cost-profit-report?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
	},
	// 2021-08-09
	costProfitReportExportExcel(params) {
		return axios.get('/back-order/cost-profit-report-export-excel?' + Qs.stringify(params, { arrayFormat: 'repeat' }))
	},
	// 2021-08-09
	costProfitReportCount(params) {
		return axios.get('/back-order/cost-profit-report-count?' + Qs.stringify(params, { arrayFormat: 'repeat' }))
	}
}